const colors = {
    black: '#000000',
    cabaret: '#cf5464',
    doveGray: '#757575',
    gray: '#a8a8a8',
    gulfStream: '#75B3B2',
    harvestGold: '#eeeeee',
    irisBlue: '#00bcd4',
    lightGray: 'rgba(225,225,225,.2)',
    lochinvar: '#338b86',
    mossGreen: '#acdaae',
    orange: '#ffa500',
    platinateBlue: '#666666',
    redOrange: '#f44336',
    white: '#ffffff',
    secondary: '#ff13a5',
    primary: '#0025CC',
    chinook: '#f5f4f4',
};

module.exports = {
    theme: {
        fontFamily: '"Lato", Helvetica, Arial, sans-serif',
        fontSize: 15,
        lineHeight: 1.65,
        app: {
            background: '#edecec',
        },
        actions: {
            true: colors.secondary,
            false: '#cc0022',
            neutral: colors.doveGray,
        },
        palette: {
            accent1Color: colors.secondary,
            aluminium: '#999999',
            black: '#000000',
            blond: '#fdf3ba',
            cabaret: '#cf5464',
            chinook: '#f5f4f4',
            colonialWhite: '#FFEEBA',
            darkOrange: '#ff8d05',
            deepCarminePink: '#f23a2f',
            desertStorm: '#f8f8f8',
            doveGray: '#757575',
            envy: '#8aab8b',
            gallery: '#efefef',
            gray: '#a8a8a8',
            gulfStream: '#75B3B2',
            harvestGold: '#eeeeee',
            irisBlue: '#00bcd4',
            lightGray: 'rgba(225,225,225,.2)',
            lochinvar: '#338b86',
            mossGreen: '#acdaae',
            offWhite: '#f9f9f9',
            orange: '#ffa500',
            pickerHeaderColor: colors.primary,
            pipi: '#FFF3CD',
            platinateBlue: '#666666',
            primary: colors.primary,
            primary1Color: colors.primary,
            primary1ColorHover: '#002fff',
            primary2Color: colors.primary,
            primary2ColorHover: '#002fff',
            primary3Color: colors.primary, // Dark
            rangeBackgroundColor: '#d3ebff',
            redOrange: '#f44336',
            secondary: '#ff13a5',
            secondary1Color: '#ff13a5',
            silver: '#c0c0c0',
            springRain: '#99bd9b',
            stack: '#8e8e8e',
            stardust: '#a0a0a0',
            tomato: '#ff574b',
            white: '#ffffff',
            wildSand: '#f4f4f4',
            yukonGold: '#786600',
        },
        accordion: {
            border: 'rgb(224, 224, 224)',
            closed: colors.white,
            content: colors.white,
            highlight: '#f5f4f4',
            open: '#f5f4f4',
            contentBackground: colors.white,
        },
        appBar: {
            color: colors.secondary,
        },
        cards: {
            header: colors.harvestGold,
        },
        datePicker: {
            calendarTextColor: 'rgba(0, 0, 0, 0.87)',
            calendarYearBackgroundColor: '#ffffff',
            color: colors.primary,
            selectColor: colors.primary,
            selectTextColor: colors.white,
            textColor: colors.white,
        },
        dropDownMenu: {
            accentColor: colors.secondary,
        },
        table: {
            head: {
                color: 'rgba(0, 0, 0, 0.87)',
                border: 'rgb(224, 224, 224)',
                background: colors.white,
                inactive: 'rgba(0, 0, 0, 0.6)',
            },
            body: {
                row: {
                    background: 'rgb(224, 224, 224)',
                    hover: 'rgba(224, 224, 224, 0.4)',
                    color: 'rgba(0, 0, 0, 0.87)',
                    border: 'rgb(224, 224, 224)',
                },
            },
        },
        tabs: {
            backgroundColor: colors.white,
            selectedTextColor: colors.irisBlue,
            textColor: colors.doveGray,
        },
        inkBar: {
            backgroundColor: colors.irisBlue,
        },
        selectField: {
            selectColor: colors.primary,
            floatingLabelColor: colors.platinateBlue,
            disabledTextColor: colors.platinateBlue,
        },
        textField: {
            floatingLabelColor: colors.platinateBlue,
            disabledTextColor: colors.platinateBlue,
        },
        secondary: colors.secondary,
        primary: colors.primary,
        sidebar: {
            backgroundColor: '#07175f',
        },
    },
    title: 'Aviogo Dashboard',
};


// WEBPACK FOOTER //
// ./src/tenants/aviogo/index.js